/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Student_2_NameInputs */

const en_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const es_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const de_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const zh_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const ar_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const fr_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const vi_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const sw_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const th_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const bs_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const ja_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const ko_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const pt_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const it_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const sv_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const nl_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const da_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const nb_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const fi_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const pl_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const ru_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const tr_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const hi_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const id_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const ms_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const cs_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const el_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const he_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const af_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

const hu_about_content_student_2_name = /** @type {(inputs: About_Content_Student_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sean McCarty`)
};

/**
* | output |
* | --- |
* | "Sean McCarty" |
*
* @param {About_Content_Student_2_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_student_2_name = /** @type {((inputs?: About_Content_Student_2_NameInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Student_2_NameInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_student_2_name(inputs)
	if (locale === "de") return de_about_content_student_2_name(inputs)
	if (locale === "zh") return zh_about_content_student_2_name(inputs)
	if (locale === "ar") return ar_about_content_student_2_name(inputs)
	if (locale === "fr") return fr_about_content_student_2_name(inputs)
	if (locale === "vi") return vi_about_content_student_2_name(inputs)
	if (locale === "sw") return sw_about_content_student_2_name(inputs)
	if (locale === "th") return th_about_content_student_2_name(inputs)
	if (locale === "bs") return bs_about_content_student_2_name(inputs)
	if (locale === "ja") return ja_about_content_student_2_name(inputs)
	if (locale === "ko") return ko_about_content_student_2_name(inputs)
	if (locale === "pt") return pt_about_content_student_2_name(inputs)
	if (locale === "it") return it_about_content_student_2_name(inputs)
	if (locale === "sv") return sv_about_content_student_2_name(inputs)
	if (locale === "nl") return nl_about_content_student_2_name(inputs)
	if (locale === "da") return da_about_content_student_2_name(inputs)
	if (locale === "nb") return nb_about_content_student_2_name(inputs)
	if (locale === "fi") return fi_about_content_student_2_name(inputs)
	if (locale === "pl") return pl_about_content_student_2_name(inputs)
	if (locale === "ru") return ru_about_content_student_2_name(inputs)
	if (locale === "tr") return tr_about_content_student_2_name(inputs)
	if (locale === "hi") return hi_about_content_student_2_name(inputs)
	if (locale === "id") return id_about_content_student_2_name(inputs)
	if (locale === "ms") return ms_about_content_student_2_name(inputs)
	if (locale === "cs") return cs_about_content_student_2_name(inputs)
	if (locale === "el") return el_about_content_student_2_name(inputs)
	if (locale === "he") return he_about_content_student_2_name(inputs)
	if (locale === "af") return af_about_content_student_2_name(inputs)
	if (locale === "hu") return hu_about_content_student_2_name(inputs)
	return en_about_content_student_2_name(inputs)
});